import { getSitePagePublicPath } from "@/lib/site-page-public-path";

// Keep this hardcoded list in sync with published grade topic pages used for footer SEO links.
export const FOOTER_GRADE_PAGE_SLUGS = [
  "kindergarten",
  "1st-grade",
  "2nd-grade",
  "3rd-grade",
  "4th-grade",
  "5th-grade",
  "middle-school",
] as const;

export type FooterGradePageSlug = (typeof FOOTER_GRADE_PAGE_SLUGS)[number];

const FOOTER_GRADE_PAGE_LABELS: Record<FooterGradePageSlug, string> = {
  kindergarten: "Kindergarten",
  "1st-grade": "1st Grade",
  "2nd-grade": "2nd Grade",
  "3rd-grade": "3rd Grade",
  "4th-grade": "4th Grade",
  "5th-grade": "5th Grade",
  "middle-school": "Middle School",
};

export const getFooterGradePageHref = (slug: FooterGradePageSlug) =>
  getSitePagePublicPath("topics", slug);

export const getFooterGradePageLabel = (slug: FooterGradePageSlug) =>
  FOOTER_GRADE_PAGE_LABELS[slug];
